import { render, staticRenderFns } from "./UpdateCrewEmail.vue?vue&type=template&id=aa5c0798&scoped=true&"
import script from "./UpdateCrewEmail.vue?vue&type=script&lang=js&"
export * from "./UpdateCrewEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5c0798",
  null
  
)

export default component.exports